import { Component, OnInit } from '@angular/core';

interface AdminItem {
    title: string;
    desc: string;
    icon: string;
    color: string;
    route: string;
}

@Component({
  selector: 'app-padrones-administracion',
  templateUrl: './padrones-administracion.component.html',
  styleUrls: ['./padrones-administracion.component.scss']
})
export class PadronesAdministracionComponent implements OnInit {

  items: AdminItem[] = [
    {
        title: 'Importar Padrón',
        desc: 'Cargue archivos PDF para generar centros médicos automáticamente.',
        icon: 'fas fa-file-medical',
        color: '#4b7bec',
        route: '/padrones/importar',
    },
    {
        title: 'Limpiar Datos',
        desc: 'Eliminar centros médicos de forma masiva por gerenciadora.',
        icon: 'fas fa-trash-alt',
        color: '#dc3545',
        route: '/centros/limpiar',
    },
    {
        title: 'Gerenciadoras',
        desc: 'Listado y configuración de entidades gerenciadoras.',
        icon: 'fas fa-book-medical',
        color: '#8B5CF6',
        route: '/gerenciadoras-listado',
    },
    {
        title: 'Historial de Importaciones',
        desc: 'Vea y controle el resumen de las últimas importaciones ejecutadas.',
        icon: 'fas fa-history',
        color: '#10b981',
        route: '/padrones/historial',
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

  trackByTitle(index: number, item: AdminItem): string {
    return item.title;
  }
}
